module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_52.dd5b687a.png";